import { lazy } from 'react';
import PageView from './PageView';

const B2BPage = lazy(() => import('src/pages/B2B'));

export const b2bRoutes = [
  {
    path: 'b2b',
    element: <PageView permission="BO_CAN_VIEW_B2BS" />,
    children: [{ element: <B2BPage />, index: true }],
  },
];
